import { useEffect } from 'react';
import { captureInboundParams, hasAnyInboundParam, safeSessionGet, safeSessionSet } from '@/lib/tracking/inbound-params';
import { trackAttributionCaptured } from '@/src/services/analytics';

const SESSION_FIRED_KEY = 'bf_attribution_fired';

/**
 * Invisible component mounted once inside BrowserRouter (at the app root).
 * On first render it:
 *  1. Snapshots any inbound URL tracking params into sessionStorage.
 *  2. Pushes a single `attribution_captured` GTM event per session.
 *
 * Using sessionStorage means the snapshot survives SPA navigations but resets
 * when the browser tab is closed, which is the desired session-scoped behaviour.
 */
export function TrackingCapture() {
  useEffect(() => {
    const params = captureInboundParams();

    if (
      params &&
      hasAnyInboundParam(params) &&
      !safeSessionGet(SESSION_FIRED_KEY)
    ) {
      trackAttributionCaptured(params);
      safeSessionSet(SESSION_FIRED_KEY, '1');
    }
  // Run once on mount only.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
